var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "41.9275mm",
    height: "41.4221mm",
    viewBox: "0 0 632.08 624.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15.95,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4.748,
    d: "M532.6 243.17l0 320.85c0,28.97 -23.49,52.46 -52.47,52.46l-419.7 0c-28.97,0 -52.46,-23.48 -52.46,-52.46l0 -419.7c0,-28.97 23.49,-52.46 52.46,-52.46l334.62 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15.95,
    strokeMiterlimit: 10,
    d: "M618.82 107.55l-289.4 289.4c-2,2 -4.45,3.51 -7.13,4.38l-102.35 33.56c-14.04,4.6 -27.36,-8.71 -22.75,-22.76l33.56 -102.35c0.88,-2.69 2.38,-5.13 4.38,-7.13l289.4 -289.4c7.04,-7.05 18.46,-7.05 25.5,0l68.79 68.79c7.04,7.04 7.04,18.46 0,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15.95,
    strokeMiterlimit: 10,
    d: "M210.28 372.21c11.44,3.23 22.23,9.36 31.23,18.36 9,9 15.13,19.8 18.36,31.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil0 str1",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15.95,
    strokeMiterlimit: 10,
    x1: 475.74,
    y1: 62.05,
    x2: 570.02,
    y2: 156.34
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.122b2d2c2a0a74edb5792b48e56d2d24.svg";
export { ForwardRef as ReactComponent };